import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import '../../atoms/buttons/enums.js';
import { isRTL, wrapRichTextTables } from '../../utilities/dom-helpers/index.js';
import { BackgroundVariant } from './types.js';
import '../../atoms/buttons/generic-button2.0/index.js';
import css_248z from './text-only-block.scss.js';

class TextOnlyBlock extends s {
    constructor() {
        super(...arguments);
        this.useLightDomDescription = false;
        this.description = '';
        this.rtl = false;
        this.variant = BackgroundVariant.WHITE;
        this.fullWidthBackground = false;
        this.flatLayout = false;
    }
    firstUpdated() {
        // If `description` wasn't provided as a property, allow using light DOM content
        try {
            if (!this.description || this.description === '') {
                const initialContent = this.innerHTML && this.innerHTML.trim();
                if (initialContent) {
                    const normalizedContent = initialContent.toLowerCase();
                    const containsEmbeddedForm = TextOnlyBlock.LIGHT_DOM_FORM_MARKERS.some(marker => normalizedContent.includes(marker));
                    // Keep form/script embeds in light DOM so Forms scripts can initialize them.
                    if (containsEmbeddedForm) {
                        this.useLightDomDescription = true;
                        this.requestUpdate();
                        return;
                    }
                    this.description = initialContent;
                    // Clear light DOM to avoid duplicate content
                    this.innerHTML = '';
                    this.requestUpdate();
                }
            }
        }
        catch (e) {
            // Log the error so it's not silently swallowed (Sonar: handle exceptions)
            // Rendering will still use `description` if present.
            // eslint-disable-next-line no-console
            console.warn('TextOnlyBlock.firstUpdated error:', e);
        }
    }
    get buttonStyleType() {
        return this.variant === BackgroundVariant.BURGUNDY ||
            this.variant === BackgroundVariant.PURPLE
            ? 'dark'
            : 'light';
    }
    get buttonColor() {
        return this.variant === BackgroundVariant.BURGUNDY ? 'burgundy' : 'purple';
    }
    renderGenericButton(type, ctaButton) {
        var _a;
        if (!(ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.url)) {
            return null;
        }
        const ctaLabel = ctaButton.title || '';
        const ctaHref = ctaButton.url;
        const ctaTarget = ctaButton.target || '_self';
        const ariaListValue = ((_a = ctaButton.ariaLabel) === null || _a === void 0 ? void 0 : _a.trim())
            ? { label: ctaButton.ariaLabel }
            : {};
        return $ `<generic-button-updated type="${type}" .color="${this.buttonColor}" .styleType="${this.buttonStyleType}" .label="${ctaLabel}" .href="${ctaHref}" .target="${ctaTarget}" .ariaList="${ariaListValue}" ?isNoFollow="${ctaButton.isNoFollow || false}" ?rtl="${this.rtl || isRTL()}" class="text-only-block__button text-only-block__button--${type}"></generic-button-updated>`;
    }
    renderCtaGroup() {
        var _a, _b;
        const hasCtas = ((_a = this.ctaPrimary) === null || _a === void 0 ? void 0 : _a.url) || ((_b = this.ctaSecondary) === null || _b === void 0 ? void 0 : _b.url);
        if (!hasCtas) {
            return null;
        }
        return $ `<div class="text-only-block__cta-group">${this.renderGenericButton('primary', this.ctaPrimary)} ${this.renderGenericButton('secondary', this.ctaSecondary)}</div>`;
    }
    render() {
        const direction = this.rtl || isRTL() ? 'rtl' : 'ltr';
        const variantClass = `text-only-block--${this.variant}`;
        const rtlClass = this.rtl || isRTL() ? 'text-only-block--rtl' : '';
        const fullWidthBackgroundClass = this.fullWidthBackground
            ? 'text-only-block--full-width-background'
            : '';
        const flatLayoutClass = this.flatLayout
            ? 'text-only-block--flat-layout'
            : '';
        const inTwoColumnsClass = this.closest('two-column-resposive-block, .cvt-layout-text-two-column__col, .columns-module-container, .column-item')
            ? 'text-only-block--in-two-columns'
            : '';
        const isRtlActive = this.rtl || isRTL();
        const rteClasses = `rte${isRtlActive ? ' rte--rtl' : ''}`;
        let descriptionContent;
        if (this.useLightDomDescription) {
            descriptionContent = o('<slot></slot>');
        }
        else {
            descriptionContent = o(wrapRichTextTables(this.description));
        }
        return $ `<section class="text-only-block ${variantClass} ${rtlClass} ${fullWidthBackgroundClass} ${flatLayoutClass} ${inTwoColumnsClass}" dir="${direction}"><div class="text-only-block__description ${rteClasses}">${descriptionContent}</div>${this.renderCtaGroup()}</section>`;
    }
}
TextOnlyBlock.styles = css_248z;
TextOnlyBlock.LIGHT_DOM_FORM_MARKERS = [
    'episerverforms',
    'data-f-type="form"',
    'data-f-metadata',
    'epi-contentfragment',
    '<img',
    'data-contentguid',
    'data-contentlink',
    '<script',
];
__decorate([
    e({ type: String })
], TextOnlyBlock.prototype, "description", void 0);
__decorate([
    e({ type: Boolean })
], TextOnlyBlock.prototype, "rtl", void 0);
__decorate([
    e({ type: String })
], TextOnlyBlock.prototype, "variant", void 0);
__decorate([
    e({ type: Object })
], TextOnlyBlock.prototype, "ctaPrimary", void 0);
__decorate([
    e({ type: Object })
], TextOnlyBlock.prototype, "ctaSecondary", void 0);
__decorate([
    e({ type: Boolean, attribute: 'full-width-background' })
], TextOnlyBlock.prototype, "fullWidthBackground", void 0);
__decorate([
    e({ type: Boolean, attribute: 'flat-layout' })
], TextOnlyBlock.prototype, "flatLayout", void 0);
customElements.define('text-only-block', TextOnlyBlock);

export { TextOnlyBlock };
